import {getBvFeatures} from "../../../../../../../../api/server-api";
import {getRelatedFeaturesFromLayout} from "../../../../../../../../misc/helpers";
import {shouldAutoSelectWizardItems} from "../../../../../../../look/lookNavigation/lookMain/lookWizard/devWizardAutoSelect";

const getWizardSelectedFeatureForPartId = (wizardSelectedValues, partId) => {
  if (!wizardSelectedValues || !partId) {
    return null;
  }
  const selectedWizardValue = Object.keys(wizardSelectedValues).map(stepIndex => {
    return wizardSelectedValues[stepIndex];
  }).find(wizardValue => {
    return wizardValue && wizardValue.selectedFeature
      && (wizardValue.partId === partId || wizardValue.selectedFeature.partId === partId);
  });

  return selectedWizardValue ? selectedWizardValue.selectedFeature : null;
};

export const featureHasRelatedFeatures = (feature) => {
  if (!feature) {
    return false;
  }
  if (Array.isArray(feature.dbFeature?.relatedFeatureIds) && feature.dbFeature.relatedFeatureIds.length) {
    return true;
  }
  return typeof feature.getFeatureRelatedFeatures === "function"
    && Array.isArray(feature.getFeatureRelatedFeatures())
    && feature.getFeatureRelatedFeatures().length;
};

const getFeatureWithRelatedFeatures = (featureGroup, layout, selectedFilters) => {
  if (!featureGroup) {
    return null;
  }

  let navItems = layout.designNavigationItems(
    {part: featureGroup},
    selectedFilters,
    "",
    false,
    "all",
    [],
    { firstFeature: null, firstConditions: null },
  );

  let navItemWithRelatedFeatures = navItems.find(navItem => featureHasRelatedFeatures(navItem.part));
  if (!navItemWithRelatedFeatures && selectedFilters && Object.keys(selectedFilters).length) {
    navItems = layout.designNavigationItems(
      {part: featureGroup},
      {},
      "",
      false,
      "all",
      [],
      { firstFeature: null, firstConditions: null },
    );
    navItemWithRelatedFeatures = navItems.find(navItem => featureHasRelatedFeatures(navItem.part));
  }

  if (navItemWithRelatedFeatures) {
    return navItemWithRelatedFeatures.part;
  }

  const featureLists = [
    ...Object.values(featureGroup.featuresList || {}),
    ...Object.values(featureGroup.featuresPartsList || {}),
  ];
  return featureLists.reduce((foundFeature, features) => {
    if (foundFeature || !Array.isArray(features)) {
      return foundFeature;
    }
    return features.find(feature => featureHasRelatedFeatures(feature)) || null;
  }, null);
};

// Normal SQFT cabinet flow depends on a manually selected wizard parent feature.
// This helper only patches the dev auto-select flow by finding a cabinet parent that can expose box related features.
export const getDevSqftRelatedParentFeature = ({
                                                  parentFeature,
                                                  featureGroup,
                                                  layout,
                                                  partId,
                                                  selectedFilters,
                                                  wizardSelectedValues,
                                                }) => {
  if (!shouldAutoSelectWizardItems()) {
    return parentFeature;
  }

  const wizardSelectedFeature = getWizardSelectedFeatureForPartId(wizardSelectedValues, partId);
  const preferredParentFeature = wizardSelectedFeature || parentFeature;

  if (featureHasRelatedFeatures(preferredParentFeature)) {
    return preferredParentFeature;
  }

  return getFeatureWithRelatedFeatures(featureGroup, layout, selectedFilters) || preferredParentFeature;
};

// Related boxes may be referenced by id but not loaded yet when the dev auto-select flow opens SQFT directly.
export const loadMissingDevSqftRelatedFeatures = ({
                                                    layout,
                                                    parentFeature,
                                                    requestedRelatedFeaturesParentId,
                                                    selectedFilters,
                                                    setRelatedFeaturesReloadCount,
                                                    setRequestedRelatedFeaturesParentId,
                                                  }) => {
  if (!shouldAutoSelectWizardItems()
    || !parentFeature
    || requestedRelatedFeaturesParentId === parentFeature.dbFeature.id) {
    return;
  }

  const relatedFeatures = parentFeature.getFeatureRelatedFeatures();
  if (!Array.isArray(relatedFeatures) || !relatedFeatures.length) {
    return;
  }

  const {noFeaturesFound} = getRelatedFeaturesFromLayout(
    relatedFeatures,
    parentFeature,
    "",
    selectedFilters
  );

  if (!noFeaturesFound.length) {
    return;
  }

  setRequestedRelatedFeaturesParentId(parentFeature.dbFeature.id);
  getBvFeatures(noFeaturesFound).then(response => {
    if (response && response.data) {
      layout.loadNewFeatures(response.data);
      setRelatedFeaturesReloadCount(count => count + 1);
    }
  });
};
